import * as THREE from 'three'

export default class Track {
    constructor(scene) {
        this.scene = scene

        const geo = new THREE.BoxBufferGeometry(10, 1, 100)
        const mat = new THREE.MeshBasicMaterial({ color: 0x22ff22 })
        this.mesh = new THREE.Mesh(geo, mat)
        this.mesh.position.set(0, -2.1, 0)
        this.scene.add(this.mesh)
        // this.mesh.rotation.x = Math.PI / 2
    }

    init(scene) {
        this.scene = scene
    }

    update() {

    }
}